import { renderV2 } from 'base/wrapped-render-v2';
import { PoMicroFrontend } from 'micro-frontend.react';

const headerAnswersBtn = document.getElementById('js-headerAnswersBtn');

document.addEventListener('DOMContentLoaded', () => {
	if (headerAnswersBtn) {
		renderV2({
			children: (
				<PoMicroFrontend route='/answers/header-button' />
			),
			attachedElement: headerAnswersBtn,
		});
	}
});
